var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isFa
    ? _c("w-fa", { staticClass: "app-fa-icon", attrs: { icon: _vm.faName } })
    : _c("span", { class: _vm.icon })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }